<template>
  <autocomplete-single name="Отделение" :items="items" :select.sync="localSelect" :loading="loadState.isLoading">
    <template v-slot:itemInfo="{item}">
      <div class="caption">
        <v-row no-gutters align-content="center">
          <v-col cols="auto"><v-avatar :color="item.comBranch.color" size="10" class="mr-1" style="margin-top:-3px"/></v-col>
          <v-col>{{item.comBranch.name}}</v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:selectedInfo="{item}">
      <v-avatar :color="item.comBranch.color" size="10" class="mr-1" style="margin-top:-2px"/> {{item.comBranch.name}} / {{item.name}}
    </template>
  </autocomplete-single>
</template>

<script>

import State from "@/plugins/state";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import {
  Entity_ComDiv,
  Entity_ComBranch
} from "../../../EntityStoreCacheService";

export default {
  components: {AutocompleteSingle},
  props:[
    'select',
  ],
  data:()=>({
    loadState: new State(),
    items:[],
    localSelect:null
  }),
  watch:{
    select(){
      this.localSelect = this.select;
   
      if(this.localSelect!==null)
        this.localSelect.id = parseInt(this.localSelect.id);
    },
    localSelect(){
      this.$emit('update:select', this.localSelect)
    }
  },
  mounted() {
    this.localSelect = this.select;

    if(this.localSelect!==null)
      this.localSelect.id = parseInt(this.localSelect.id);
    new Entity_ComDiv()
      .selects(Entity_ComDiv.id)
      .selects(Entity_ComDiv.name)
      .selects([Entity_ComDiv.comBranch,Entity_ComBranch.id].join('.'))
      .selects([Entity_ComDiv.comBranch,Entity_ComBranch.name].join('.'))
      .selects([Entity_ComDiv.comBranch,Entity_ComBranch.color].join('.'))
      .order([Entity_ComDiv.comBranch, Entity_ComBranch.id].join('.'), true)
      .order([Entity_ComDiv.name].join('.'), true)
      .page(null)
      .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
      .addStateCallback((v)=> {
        if(v.success)
          this.items = v.items;
      })
      .request();
  }
}
</script>